import { createFileRoute } from "@tanstack/react-router";
import AtlasChatGPTSeoLocal from "@/pages/blog/AtlasChatGPTSeoLocal";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  headline: "Atlas de ChatGPT: El Nuevo Buscador que Cambia el SEO Local | SEOEVOLUTION",
  description:
    "Descubre cómo Atlas de ChatGPT está revolucionando el SEO Local con búsquedas basadas en geolocalización en tiempo real. Guía completa para optimizar tu negocio en 2025.",
  image: "https://agenciaseoevolution.com/logo.png",
  author: {
    "@type": "Person",
    name: "Ángel Ruz",
    url: "https://agenciaseoevolution.com/sobre-nosotros",
  },
  publisher: {
    "@type": "Organization",
    name: "SEOEVOLUTION",
    url: "https://agenciaseoevolution.com",
    logo: {
      "@type": "ImageObject",
      url: "https://agenciaseoevolution.com/logo.png",
    },
  },
  datePublished: "2025-01-15",
  dateModified: "2025-01-15",
  mainEntityOfPage: "https://agenciaseoevolution.com/blog/atlas-chatgpt-seo-local",
  inLanguage: "es",
  keywords: "Atlas ChatGPT, SEO local 2025, posicionamiento GEO, búsquedas cerca de mí, Google SGE",
};

const breadcrumbSchema = buildBreadcrumb([
  { name: "Conocimiento", path: "/blog" },
  { name: "Atlas de ChatGPT y SEO local", path: "/blog/atlas-chatgpt-seo-local" },
]);

export const Route = createFileRoute("/blog/atlas-chatgpt-seo-local")({
  head: () => ({
    meta: [
      { title: "Atlas de ChatGPT: El Nuevo Buscador que Cambia el SEO Local | SEOEVOLUTION" },
      {
        name: "description",
        content:
          "Descubre cómo Atlas de ChatGPT está revolucionando el SEO Local con búsquedas basadas en geolocalización en tiempo real. Guía completa para optimizar tu negocio en 2025.",
      },
      { name: "keywords", content: "Atlas ChatGPT, SEO local 2025, posicionamiento GEO, búsquedas cerca de mí, Google SGE" },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://agenciaseoevolution.com/blog/atlas-chatgpt-seo-local" },
      { property: "og:title", content: "Atlas de ChatGPT: El Nuevo Buscador que Cambia el SEO Local | SEOEVOLUTION" },
      {
        property: "og:description",
        content:
          "Descubre cómo Atlas de ChatGPT está revolucionando el SEO Local con búsquedas basadas en geolocalización en tiempo real. Guía completa para optimizar tu negocio en 2025.",
      },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Atlas de ChatGPT: El Nuevo Buscador que Cambia el SEO Local | SEOEVOLUTION" },
      {
        name: "twitter:description",
        content:
          "Descubre cómo Atlas de ChatGPT está revolucionando el SEO Local con búsquedas basadas en geolocalización en tiempo real. Guía completa para optimizar tu negocio en 2025.",
      },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/blog/atlas-chatgpt-seo-local" }],
    scripts: [ldJson(breadcrumbSchema), { type: "application/ld+json", children: JSON.stringify(articleSchema) }],
  }),
  component: AtlasChatGPTSeoLocal,
});
